import React, { useEffect, useState } from "react";
import WeekForm from "./WeekForm";
import DayList from "./DayList";
import "./WeekList.css";
import binicon from "../../../images/bin-icon.svg";
import { Button, Form } from "react-bootstrap";
import { use } from "react";
import editicon from "../../../images/edit-icon.svg";
import DeleteModel from "../model/DeleteModel";

// import { Search, Plus, Calendar, Clock, FileText, Mic, Edit, Trash2, ChevronRight } from 'lucide-react';

const WeekList = ({
  weeks,
  searchText,
  onSearchWeek,
  onAddWeek,
  onDeleteWeek,
  onAddDay,
  handelDaySave,
  handelContentSave,
  onDeleteContent
}) => {
  const [showForm, setShowForm] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteModelShow, setDeleteModelShow] = useState(false);
  const [deletedData, setDeletedData] = useState(null);
  const handleAddWeek = (weekData) => {
    // Call API or update state here
  };

  const handelShowForm = () => {
    setEditData(null);
    setShowForm(true);
  };
  const onEditWeek = (data) => {
    // Call API or update state here
    setEditData(data);
    setShowForm(true);
  };

  const showDeleteModel = (data) => {
    setDeletedData(data);
    setDeleteModelShow(true);
  };

  return (
    <>
      <div className="week-container">
        <div className="add-doctor">
          <Form>
            <Form.Group controlId="searchInput">
              <Form.Control
                type="search"
                aria-label="Search"
                value={searchText}
                onChange={onSearchWeek}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault(); // prevent form submission/reload
                    // handelSearchSubmit();
                  }
                }}
                placeholder="Search by week name"
              />
            </Form.Group>
          </Form>

          <Button onClick={handelShowForm} className="filled-btn">
            + Add Week
          </Button>

          <WeekForm
            showForm={showForm}
            setShowForm={setShowForm}
            onAddWeek={onAddWeek}
            editData={editData}
          />
        </div>
        {weeks?.map((week) => (
          <div key={week.id} className="week-card">
            <div className="week-header-content">
              <h2 className="week-title">{week.title}</h2>
              <div className="d-flex justify-content-between align-items-center">
                <button
                  onClick={() => onEditWeek(week)}
                  className="btn edit-btn week-edit-btn"
                >
                  {" "}
                  <img src={editicon} alt="delete" />
                </button>

                <button
                  // onClick={() => onDeleteWeek(week._id)}
                  onClick={() => showDeleteModel(week._id)}
                  className="btn edit-btn week-delete-btn"
                >
                  {" "}
                  <img src={binicon} alt="delete" />
                </button>
              </div>
            </div>
            <p className="week-description">{week.description}</p>
            <div className="d-flex justify-content-between align-items-center">
              <p className="days-count">Days ({week?.days?.length}/7)</p>
              {/* <button
              onClick={() => onAddDay(week.id)}
              className="btn btn-secondary add-day-btn"
            >
              + Add Day
            </button> */}
            </div>

            {week?.days.length === 0 ? (
              <div className="no-days">
                <span className="clock-icon">⏳</span>
                <p>No days created yet</p>
              </div>
            ) : (
              <DayList
                days={week?.days}
                onAddDay={onAddDay}
                weekId={week._id}
                weekNumber={week.weekNumber}
                handelDaySave={handelDaySave}
                onHandleSaveContent={handelContentSave}
                onDeleteContent={onDeleteContent}
              />
            )}
            {[...Array(7 - week?.days?.length)].map((_, index) => (
              <div key={`empty-${index}`} className="empty-day"></div>
            ))}
          </div>
        ))}
        {weeks?.length === 0 && (
          <>

            <div class="no-days-card">
              <div class="icon">
                <i class="fa-regular fa-clock"></i>
              </div>
              <div class="text"> No week has been created or found yet.</div>
            </div>
          </>


        )}

      </div>
      {
        deleteModelShow &&
        <DeleteModel setDeleteModelShow={setDeleteModelShow} deleteModelShow={deleteModelShow} handelDelete={onDeleteWeek} deletedData={deletedData} type="Week" />
      }
    </>
  );
};

export default WeekList;
